import { useState, useCallback } from 'react';
import api from '../Api';

export const useCustomerProjectAccess = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Grant customer access to a project
  const grantAccess = useCallback(async (projectId, customerId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.post(`/projects/${projectId}/customers/${customerId}/grant`);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to grant access');
      setLoading(false);
      throw err;
    }
  }, []);

  // Revoke customer access from a project
  const revokeAccess = useCallback(async (projectId, customerId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.delete(`/projects/${projectId}/customers/${customerId}/revoke`);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to revoke access');
      setLoading(false);
      throw err;
    }
  }, []);

  // Get all customers with access to a project
  const getProjectCustomers = useCallback(async (projectId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(`/projects/${projectId}/customers`);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch customers');
      setLoading(false);
      throw err;
    }
  }, []);

  // Get all projects a customer has access to
  const getCustomerProjects = useCallback(async (customerId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(`/customers/${customerId}/projects`);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch projects');
      setLoading(false);
      throw err;
    }
  }, []);

  return {
    grantAccess,
    revokeAccess,
    getProjectCustomers,
    getCustomerProjects,
    loading,
    error,
  };
};
